export default __webpack_public_path__ + "static/media/values.0eb5e50b.jpg";